import React from 'react';
import MagicForm from '../../../../Components/Form/MagicForm';
import { userMetaDataSchemes } from './UserMetaDataSchemes';
import { MetaDataItem } from '../../../Manager/Components/Workers/TherapistDetail/TherapistDetail';
import { useCreateUserMetaTranslationMutation } from '../../../../graphql/graphql';
import useMeta from '../../Hooks/useMeta';

interface Props {
	userId: string;
	metaDataItem: MetaDataItem;
	onSuccess: () => void;
	language?: string;
}

const UserMetaDataEdit: React.FC<Props> = ({
	userId,
	metaDataItem,
	onSuccess,
	language,
}) => {
	const { createUserMeta } = useMeta();
	const [createMetaTranslation] = useCreateUserMetaTranslationMutation();
	const handleSubmit = async (values: Record<string, any>) => {
		console.log('values', values);
		if (language) {
			await createMetaTranslation({
				input: [
					{
						userId: userId,
						key: metaDataItem.key,
						value: values[metaDataItem.key],
						language: language,
					},
				],
			});
		} else {
			await createUserMeta(
				userId,
				metaDataItem.key,
				values[metaDataItem.key] ?? null,
			);
		}

		onSuccess();
	};

	if (!metaDataItem) {
		return <></>;
	}

	return (
		<MagicForm
			registerForChanges
			formScheme={userMetaDataSchemes[metaDataItem.key]}
			onSubmit={handleSubmit}
			defaultValues={{ [metaDataItem.key]: metaDataItem.value }}
		/>
	);
};

export default UserMetaDataEdit;
